module.exports = __webpack_public_path__ + "static/media/man-providing-remote-support.ce80845e.jpg";